import React from "react";
import styles from "./Tabs.module.scss";
import classnames from "classnames";
import find from "lodash/find";

export interface Tab {
  key: string;
  label: React.ReactNode;
  content: React.ReactNode;
  "data-testid"?: string;
}

interface TabsProps {
  tabs: Tab[];
  selectedTabKey: string;
  onTabChange: (key: string) => void;
}

export default function Tabs({ tabs, selectedTabKey, onTabChange }: TabsProps) {
  const selectedTabContent = find(tabs, { key: selectedTabKey })?.content;

  return (
    <div className="height-100 flex-column">
      <div className={styles.tabs}>
        {tabs.map(
          ({ key, label, "data-testid": dataTestId = `tab-${key}` }) => (
            <div
              key={`tab-label-${key}`}
              id={`tab-${key}`}
              data-testid={dataTestId}
              className={classnames(styles.tab, {
                [styles.selected]: selectedTabKey === key,
              })}
              onClick={() => onTabChange(key)}
            >
              {label}
            </div>
          ),
        )}
      </div>

      <div className="flex-1 min-height-0">{selectedTabContent}</div>
    </div>
  );
}
